import React, { useEffect, useMemo } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';
import isArray from 'lodash/isArray';
import { useSelector } from 'react-redux';

// GLOBAL FUNCTIONS
import { controlName } from 'functions';

// HELPERS
import { useReport } from '../helpers/getReportData';

// CORE COMPONENTS
import Form from 'core/form/Form';

// VARIABLES
const SORDER_OPTIONS = [
  {
    label: 'Ascending',
    value: 'ascending'
  },
  {
    label: 'Descending',
    value: 'descending'
  }
]

// MAIN COMPONENT
const ChartFields = ({ chartData, ...props }) => {

  // REDUX
  const { reportChartType = [] } = useSelector(state => state.lookups);

  // FORMIK
  const { values, setFieldValue } = useFormikContext();

  // CONTEXT
  const {report_data: { header = {} } = {} } = useReport();

  // MEMOS
  const chartFields = useMemo(
    () => isArray(reportChartType) ? reportChartType.find(({ chart_type_id }) => String(chart_type_id) === String(values.chart_type_id))?.chart_field || [] : [],
    [values.chart_type_id, reportChartType]
  )

  useEffect(
    () => {
      chartFields.forEach((_field, i) => {
        setFieldValue(controlName('field_value', 'chart_field', i), chartData?.chart_field[i]?.field_value || '')
      });
    },
    [chartFields, chartData, setFieldValue]
  )

  // RENDER
  return chartFields.map(({
    field_code,
    field_name
  }, i) => (
    <Form.Select
      key={i}
      name={controlName('field_value', 'chart_field', i)}
      label={field_name}
      options={field_code === 'sorder' ? SORDER_OPTIONS : header}
      useNone
      {...props}
    />
  ));
};

// EXPORT
export default ChartFields;
